<span class="nimbus-filter-summary-input-mask-summary">{{ summary }}</span>
